import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgImgPlaceholder = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 48,
	height: 48,
	viewBox: "0 0 48 48",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		x: .5,
		y: .5,
		width: 47,
		height: 47,
		rx: 3.5,
		fill: "#E4E6F8",
		stroke: "#D6D8F0"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M17.5833 32.25C17.0792 32.25 16.6476 32.0705 16.2885 31.7115C15.9295 31.3524 15.75 30.9208 15.75 30.4167V17.5833C15.75 17.0792 15.9295 16.6476 16.2885 16.2885C16.6476 15.9295 17.0792 15.75 17.5833 15.75H30.4167C30.9208 15.75 31.3524 15.9295 31.7115 16.2885C32.0705 16.6476 32.25 17.0792 32.25 17.5833V30.4167C32.25 30.9208 32.0705 31.3524 31.7115 31.7115C31.3524 32.0705 30.9208 32.25 30.4167 32.25H17.5833ZM18.5 28.5833H29.5L26.0625 24L23.3125 27.6667L21.25 24.9167L18.5 28.5833ZM20.7917 22.1667C21.1736 22.1667 21.4983 22.033 21.7656 21.7656C22.033 21.4983 22.1667 21.1736 22.1667 20.7917C22.1667 20.4097 22.033 20.0851 21.7656 19.8177C21.4983 19.5503 21.1736 19.4167 20.7917 19.4167C20.4097 19.4167 20.0851 19.5503 19.8177 19.8177C19.5503 20.0851 19.4167 20.4097 19.4167 20.7917C19.4167 21.1736 19.5503 21.4983 19.8177 21.7656C20.0851 22.033 20.4097 22.1667 20.7917 22.1667Z",
		fill: "white"
	})]
});
export default SvgImgPlaceholder;
